import { useLocation, matchPath } from "react-router-dom";
import Seo from "@/components/Seo";
import { ALL_COMBOS } from "@/data/local-landing";

// path pattern -> { title, description, noindex }
const STATIC_ROUTE_META = [
  {
    path: "/",
    title: "Smart Finance Solutions",
    description:
      "Sahyog Finance & Noble Infinity — 14 loan products (Personal, Business, Agriculture, Mortgage, Housing, Cattle, FD, Credit Card, Social, Plot, Gold, Loan Against Security Deposit) starting at 6.5%. No CIBIL required.",
  },
  {
    path: "/about",
    title: "About Us",
    description:
      "Sahyog Finance & Noble Infinity Asset Management — building trust, creating wealth, empowering growth. Integrated financial services for individuals, MSMEs, agriculture and corporates across India.",
  },
  {
    path: "/leadership",
    title: "Leadership · Digantkumar I. Gamit",
    description:
      "Meet Digantkumar I. Gamit — Managing Director & Founder of Sahyog Finance & Noble Infinity Asset Management. Principles, focus areas and leadership philosophy.",
  },
  {
    path: "/privacy",
    title: "Privacy Policy",
    description:
      "Sahyog Finance Privacy Policy — how we collect, use, share and protect your personal data, KYC information, financial records and your rights.",
  },
  {
    path: "/terms",
    title: "Terms & Conditions (MITC)",
    description:
      "Sahyog Finance Terms & Most Important Terms and Conditions (MITC) governing loan disbursement, repayment, interest, prepayment, default, GST and grievance redressal.",
  },
  {
    path: "/refund",
    title: "Cancellation & Refund Policy",
    description:
      "Rules for cancelling a Sahyog Finance loan application, prepayment & foreclosure, refund of excess payments, and rejection terms.",
  },
  {
    path: "/careers",
    title: "Careers & Partnership Program",
    description:
      "Join Sahyog Finance as Advisor, DSA, Associate Partner or Agency. 6-level hierarchy, monthly incentives up to ₹2,00,000+, foreign trips, no income limit.",
  },
  {
    path: "/loan-rates",
    title: "Loan Interest Rates & Charges",
    description:
      "Transparent loan interest rates from 1.25%. Personal, Business, Agriculture, Mortgage, Housing & more. Compare ROI, tenure and processing fees.",
  },
  {
    path: "/hot-offers",
    title: "Hot Offers & Limited-Time Deals",
    description:
      "Festival offers, reduced ROI, zero processing fee deals and partner bonuses from Sahyog Finance. New offers added every month.",
  },
  {
    path: "/blogs",
    title: "Financial Insights & Blogs",
    description:
      "Read expert insights on personal finance, business loans, EMI planning, credit health, MSME funding, agriculture finance and investment strategy.",
  },
  {
    path: "/blogs/:slug",
    title: "Blog",
    description:
      "Expert financial insights from Sahyog Finance & Noble Infinity Asset Management.",
  },
  {
    path: "/investors",
    title: "Investor Relations",
    description:
      "Noble Infinity Asset Management — investor relations, fund performance, governance and contact information for institutional and HNI investors.",
  },
  {
    path: "/customer-services",
    title: "Customer Services & Support",
    description:
      "Get support for your loan, EMI, statement requests, foreclosure, NOC and account queries. WhatsApp, phone, email and branch-level assistance.",
  },
  {
    path: "/csr",
    title: "Corporate Social Responsibility (CSR)",
    description:
      "Sahyog Finance & Noble Infinity CSR initiatives — education, rural development, women empowerment, healthcare and skill development in Tapi, Gujarat.",
  },
  {
    path: "/policies",
    title: "Policy Hub",
    description:
      "Loan policies, fair practice code, KYC, privacy, interest-rate policy and customer protection guidelines from Sahyog Finance.",
  },
  {
    path: "/grievance",
    title: "Grievance Redressal",
    description:
      "File a complaint with Sahyog Finance. 7-level escalation matrix, defined SLAs (24-hour acknowledgement, 15-day final closure) and Managing Director email.",
  },
  {
    path: "/training",
    title: "Training Programs",
    description:
      "Training & certification programs for DSAs, Advisors and Associate Partners. Sales, compliance, KYC, product knowledge and digital tools.",
  },
  {
    path: "/governance",
    title: "Corporate Governance",
    description:
      "Sahyog Finance & Noble Infinity Asset Management corporate governance — board composition, committees, audit oversight and ethics framework.",
  },
  {
    path: "/vision",
    title: "Vision & Mission",
    description:
      "Vision & mission of Sahyog Finance and Noble Infinity Asset Management — building inclusive, trusted, technology-led financial services across Bharat.",
  },
  // Apply / partner / admin = noindex
  {
    path: "/apply/:type",
    title: "Apply Online",
    description: "Apply for a loan or partnership with Sahyog Finance.",
    noindex: true,
  },
  { path: "/partner/login", title: "Partner Login", noindex: true },
  { path: "/partner/dashboard", title: "Partner Dashboard", noindex: true },
  { path: "/admin", title: "Admin Console", noindex: true },
  { path: "/admin/leads", title: "Admin · Leads", noindex: true },
  { path: "/admin/applications", title: "Admin · Applications", noindex: true },
  { path: "/admin/grievances", title: "Admin · Grievances", noindex: true },
  { path: "/admin/offers", title: "Admin · Offers", noindex: true },
  { path: "/admin/blogs", title: "Admin · Blogs", noindex: true },
  { path: "/admin/onboarding-log", title: "Admin · Onboarding Log", noindex: true },
];

// Dynamically generate one entry per /loan/:combo page (the 12 local landing pages)
const LOCAL_ROUTE_META = ALL_COMBOS.map((c) => ({
  path: c.path,
  title: c.seoTitle,
  description: c.seoDescription,
}));

const ROUTE_META = [...STATIC_ROUTE_META, ...LOCAL_ROUTE_META];

export default function RouteSeo() {
  const { pathname } = useLocation();
  const match = ROUTE_META.find((r) => matchPath({ path: r.path, end: true }, pathname));
  const meta = match || ROUTE_META[0];
  return (
    <Seo
      title={meta.title}
      description={meta.description}
      path={pathname}
      noindex={meta.noindex}
    />
  );
}
